export default {
  'inbox.delete.success': 'Item deleted successfully.',
  'inbox.field.description': 'Description',
  'inbox.field.title': 'Title',
  'inbox.field.contact': 'Contact',
  'inbox.field.message': 'Message',
  'inbox.title.create': 'Create item',
  'inbox.field.accepted_status': 'Accepted',
  'inbox.status.accepted': 'Accepted',
  'inbox.field.status': 'Status',
  'agent-inbox.field.from_email': 'From',
  'agent-inbox.field.from_name': 'From',
  'agent-inbox.field.subject': 'Subject',
  'agent-inbox.field.created_at': 'Created At',
  'agent-inbox.field.message': 'Message',
  'agent-inbox.field.type': 'Type',
  'agent-inbox.field.sub_type': 'Sub Type',
  'agent-inbox.field.folder': 'Folder',
  'agent-inbox.title.content': 'Content',
  'inbox.tab.email': 'Email',
  'inbox.email_content': 'Email content',
  'inbox.open_in_mailbox': 'Open in Mailbox',
  'inbox.preview_unavailable': 'Preview is not available for this file type.',
  'inbox.download_attachment': 'Download',
  'inbox.suggestions': 'Suggestions',
  'inbox.suggestion_prompt': 'What would you like to do with this email?',
  'inbox.view_markdown': 'View markdown',
  'inbox.markdown_preview': 'Markdown preview',
  'inbox.attachments.title': 'Inbox Attachments',
  'inbox.attachments.field.name': 'Attachment',
  'inbox.attachments.field.type': 'Type',
  'inbox.attachments.field.inbox_item': 'Inbox Item',
  'inbox.attachments.search_placeholder': 'Search by file name...',
  'inbox.suggestion.view_pending': 'View the suggestion: {name}',
  'inbox.flow.running':
    'AI is working on it: {flows}. The suggestion shows up here when it is ready.',
  'inbox.flow.queued': 'checking the labels',
  'inbox.flow.failed': '{flow} did not finish',
  'inbox.flow.retry': 'Retry',
  'inbox.flow.name.pre_alert': 'shipment suggestion (pre-alert)',
  'inbox.flow.name.isf': 'ISF suggestion',
  'inbox.status.processing': 'Processing',
  'inbox.status.review': 'To review',
  'inbox.status.review_tip': 'Waiting for review: {suggestions}',
  'inbox.status.pending': 'To do',
  'inbox.status.done': 'Done',
  'inbox.status.ignored': 'Ignored',
  'inbox.status.processing.desc':
    'AI is working on this email (a flow or a suggestion being generated). It updates by itself when done.',
  'inbox.status.processing.desc_no_label':
    'AI is generating a suggestion for this email. It updates by itself when done.',
  'inbox.status.review.desc':
    'AI has made suggestions for this email. Open it to accept or reject them.',
  'inbox.status.pending.desc':
    'Nobody has handled this email yet and there is no suggestion. Add a label or use a suggestion button.',
  'inbox.status.pending.desc_no_label':
    'Nobody has handled this email yet and there is no suggestion. Use a suggestion button.',
  'inbox.status.done.desc': 'Handled: a suggestion was accepted, or someone marked it done.',
  'inbox.status.ignored.desc':
    'Marked as not needing any action. Unignore to put it back to To do.',
  'inbox.status.set.pending': 'Mark as to do',
  'inbox.status.set.done': 'Mark as done',
  'inbox.status.set.ignored': 'Ignore',
  'inbox.status.unignore': 'Unignore',
  'inbox.delete_selected': 'Delete',
  'inbox.delete_selected.confirm':
    'Delete the {count} selected item(s) and their attachments? They cannot be restored.',
  'suggestion.reject': 'Reject',
  // where the values of an AI suggestion came from (ISF, create shipment)
  'suggestion.source.read_from': 'Read from',
  'suggestion.source.email': 'Email body',
  'suggestion.source.agree': 'Same in {names}',
  'suggestion.source.conflict': 'The files disagree: {values}',
  'suggestion.source.conflicts': 'The files disagree on these fields, please check them:',
  'suggestion.source.use': 'Use this value',
  'suggestion.source.unrelated':
    '{name} looks like a different shipment and was not used: {reason}',
  'suggestion.source.single': 'From {name}',
  'suggestion.source.carrier': 'Carrier tracking',
  // common-api's check of the MBL / HBL / container numbers against the text of the files
  'suggestion.verification.found': 'Verified: found in {name}',
  'suggestion.verification.not_found': 'Not verified: not found in the text of the files',
  'suggestion.verification.no_text':
    'Not verified: read from a scan or an image, which cannot be checked',
  'suggestion.verification.unknown_scac':
    "Not verified: {prefix} is not a known carrier code, this may be an agent's bill",
  'suggestion.verification.check_digit': 'Not verified: the container check digit is wrong',
  'suggestion.verification.booking_no':
    "Not verified: this looks like the carrier's booking number, not the B/L number",
  // update_shipment from the pre_alert flow: the email matched an existing shipment
  'suggestion.update_shipment.title':
    'Update shipment {shipment} with these values from the email?',
  'suggestion.update_shipment.field': 'Field',
  'suggestion.update_shipment.current': 'Now',
  'suggestion.update_shipment.new': 'From the email',
  'suggestion.update_shipment.container': 'container {name}',
  'suggestion.update_shipment.not_changed': 'Not changed: {count}',
  'suggestion.update_shipment.reason.manual': 'changed by hand on the shipment',
  'suggestion.update_shipment.reason.skip_fields': 'set not to be updated automatically',
  'suggestion.update_shipment.reason.unclear':
    'could not be compared with the current value, so it was left as is',
  'suggestion.update_shipment.accept': 'Update shipment',
  'suggestion.update_shipment.success': 'Shipment updated.',
  'suggestion.match.ambiguous':
    '{number} matches {count} shipments ({numbers}). This suggestion is for {shipment}; check that it is the right one.',
  // picking the files an ISF / shipment suggestion is read from
  'suggestion.select_files.max': 'At most {max} files can be read at once ({count} selected).',
  'suggestion.select_files.unsupported': 'Not supported. Save .doc files as .docx.',
  'suggestion.select_files.logo':
    'Looks like a signature logo, so it is not read unless you tick it.',
  'suggestion.select_files.generate': 'Generate',
  'suggestion.reading': 'Reading the files, this can take up to half a minute…',
  'suggestion.pick_files': 'Pick other files',
  'suggestion.generating':
    'This suggestion is already being generated for this email. It will show here when it is ready.',
  'suggestion.generating.timeout':
    'It is still being generated. Please open this email again in a moment.',
};
